var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ppInfo" }, [
    _c("div", { staticClass: "projectInfo" }, [
      _c("p", { staticClass: "projectInfo_title bold" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("workPermit.projectinfo")) + "\n    "
        ),
      ]),
      _vm._v(" "),
      _vm.currentWorkPermit.isTenantProject
        ? _c("div", { staticClass: "project-info__content" }, [
            _c("div", { staticClass: "projectInfo_box" }, [
              _c("p", { staticClass: "projectInfo_box-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("workPermit.tenant")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "projectInfo_box-content" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      (_vm.company && _vm.company.name) || _vm.$t("emptyValue")
                    ) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "projectInfo_box" }, [
              _c("p", { staticClass: "projectInfo_box-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("mainContractor")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "projectInfo_box-content" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.mainContractor || _vm.$t("emptyValue")) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.building
              ? _c("div", { staticClass: "projectInfo_box" }, [
                  _c("p", { staticClass: "projectInfo_box-title" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("workPermit.building")) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "projectInfo_box-content" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.building) + "\n        "
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "projectInfo_box" }, [
              _c("p", { staticClass: "projectInfo_box-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tenancy.floor")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "projectInfo_box-content" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.project.floors
                        ? _vm.project.floors.join(", ")
                        : _vm.$t("emptyValue")
                    ) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "projectInfo_box" }, [
              _c("p", { staticClass: "projectInfo_box-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tenancyProject.projectPremises")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "projectInfo_box-content" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.showLocation) + "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "projectInfo_box" }, [
              _c("p", { staticClass: "projectInfo_box-title" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("tenancy.type")) + "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "projectInfo_box-content" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.tenancyTypeDisplay) + "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "projectInfo_box" }, [
              _c("p", { staticClass: "projectInfo_box-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("workPermit.projectDes")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "projectInfo_box-content" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.project.description || _vm.$t("emptyValue")) +
                    "\n        "
                ),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "project-info__content" }, [
            _c("div", { staticClass: "projectInfo_box" }, [
              _c("p", { staticClass: "projectInfo_box-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.isPo
                        ? _vm.$t("project.po.number")
                        : _vm.$t("project.contract.number")
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "projectInfo_box-content" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.project.number || _vm.$t("emptyValue")) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "projectInfo_box" }, [
              _c("p", { staticClass: "projectInfo_box-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tender.general.projectDescription")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "projectInfo_box-content" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.poDescription) + "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "projectInfo_box vendor-name" }, [
              _c("p", { staticClass: "projectInfo_box-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("mainContractorName")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "projectInfo_box-content " }, [
                _vm._v("\n          " + _vm._s(_vm.vendorName) + "\n        "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "projectInfo_box" }, [
              _c("p", { staticClass: "projectInfo_box-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("project.purchaseOrder.site")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "projectInfo_box-content" }, [
                _vm._v("\n          " + _vm._s(_vm.vendorSite) + "\n        "),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "projectInfo_box" }, [
              _c("p", { staticClass: "projectInfo_box-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("workPermit.building")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "projectInfo_box-content" }, [
                _vm._v("\n          " + _vm._s(_vm.building) + "\n        "),
              ]),
            ]),
            _vm._v(" "),
            _vm.hadDlpDate
              ? _c(
                  "div",
                  { staticClass: "projectInfo_box work-permit-dlp-date" },
                  [
                    _c("p", { staticClass: "projectInfo_box-title" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("project.workPermitDlpDate")) +
                          "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "projectInfo_box-content" }, [
                      _vm._v(
                        "\n          " + _vm._s(_vm.dlpDate) + "\n        "
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
    ]),
    _vm._v(" "),
    _vm.isTenantProject && _vm.currentWorkPermit.type === "WORK"
      ? _c("div", { staticClass: "mainContratorInfo" }, [
          _c("p", { staticClass: "mainContratorInfo_title bold" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("workPermit.mainContractorWorkPermit")) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mainContratorInfo_content" }, [
            _c("div", { staticClass: "mainContratorInfo_duration" }, [
              _c("p", { staticClass: "bold" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("workPermit.duration")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.pp.duration || _vm.$t("emptyValue")) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mainContratorInfo_status" }, [
              _c("p", { staticClass: "bold" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("tenancyProject.status")) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "content" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("customStatusLabel")(_vm.pp.status)) +
                    "\n        "
                ),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }